import { ROUTER_AGREEMENT, ROUTER_HABC_PREFIX, ROUTER_HABC_QUESTIONNAIRE_PREFIX, ROUTER_OUTSIDE_SUCCESS, ROUTER_QUESTIONNAIRE_PREFIX, ROUTER_VERIFICATION } from 'constants/outside-router';
import { isEmpty, isNumber, pickBy } from 'lodash';
import numeral from 'numeral';

// 校验数据是否为null或undefined
export function isNull(obj: any) {
  if (obj === null || obj === undefined) {
    return true;
  }
  return false;
}

// 校验数据是否为空（包含null、undefined、空字符串、空数组以及空对象）
// 不包括数字为零、布尔值为false的情况
export function isValEmpty(obj: any) {
  if (isNull(obj)) {
    return true;
  }
  if (typeof obj === 'string') {
    return obj.length === 0;
  }
  if (obj instanceof Array) {
    return obj.length === 0;
  }
  if (obj instanceof Object) {
    return Object.keys(obj).length === 0;
  }
  return false;
}

// 密码强度检验
export function pwdCheckStrong(value: string, minLength?: number): number {
  var modes = 0;
  if (!value || value?.length < (minLength || 8)) return modes;
  if (/\d/.test(value)) modes++; //数字
  if (/[a-z]/.test(value)) modes++; //小写
  if (/[A-Z]/.test(value)) modes++; //大写
  if (/\W/.test(value)) modes++; //特殊字符
  if (
    !/^[\da-zA-Z`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]*$/g.test(value)
  )
    modes = 0; //需要包含数字、大写字母、小写字母、符号四种，存在第五种情况直接判定非常不安全
  return modes;
}

export const tempCodeAndColorMap = {
  MIOTECH: '#38D6CA',
  HKEX: '#13436B',
  TCFD: '#1DA8CF',
  SFDR: '#78BEE3',
  SDGS: '#55AC7A',
  ANTA: '#AA0000',
  SGX: '#C1D72F',
  GRI: '#1158A6',
};

export const formatBigNumber = (value: any, digit = 4) => {
  // 后端传入的科学计数法是string类型的...先转换一下
  let dealWithNumber = Number(value);

  // 转换以后如果是乱七八糟的则直接返回
  if (isNaN(dealWithNumber)) {
    return value;
  }

  // TODO: 改动太大有风险, 周一再上
  // let data = dealWithNumber.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/) as RegExpMatchArray;

  // // 小数点后, e之前的值
  // let decimal: string;
  // // e后面的值
  // let precision: any;

  // [decimal, precision] = data;

  // // 科学计数法转为正常数字
  // let normalNumber = dealWithNumber.toFixed(Math.max(0, (decimal || '').length - precision));

  // // 保留最多4位小数, 千分位加‘,’
  // return numeral(normalNumber).format('0,0[.][0000]');

  return numeral(dealWithNumber).format(`0,0[.][${'0'.repeat(digit)}]`);
};

export const getUsername = (data: { lastName: string; firstName: string }) => {
  if (isValEmpty(data)) {
    return '-';
  }

  return `${data.lastName}${data.firstName}`;
};

export const commonSearchRules = (searchValue: string, matchingValue: string) => {
  return matchingValue.toLowerCase().includes(searchValue.trim().toLowerCase());
};

export const getDealWithFile = (file: File, existedFileNames: string[]): File => {
  let hasTheSameFileName = existedFileNames?.some(item => item === file.name);

  if (hasTheSameFileName) {
    if (file.name.includes('.')) {
      const type = file.name.split('.').slice(-1);
      const content = file.name.split(`.${type[0]}`);

      file = new File([file], `${content[0]}(1).${type}`, { type: file.type });
      return getDealWithFile(file, existedFileNames);
    } else {
      file = new File([file], `${file.name}(1)`, { type: file.type });
      return getDealWithFile(file, existedFileNames);
    }
  } else {
    return file;
  }
};

export const replaceDoubleBraces = (str?: string, result?: string[]) => {
  if (!str || !result) return '';
  return str
    .replace(/{{(\d+?)}}/g, (_, g1) => (result[g1] ? `<span class="highlight"> ${result[g1]} </span>` : ''))
    .replace(/\n/g, '<br/>');
};

// 保留两位小数
export function formatNumWithTwoDigit(
  value?: string | number | null,
  _defaultStr: string | number = '-',
  isPadZero: boolean = true,
) {
  return formatNumWithDigit(value, 2, _defaultStr, isPadZero);
}

export function formatNumWithDigit(
  value?: string | number | null,
  digit: number = 4,
  _defaultStr: string | number = '-',
  isPadZero: boolean = false,
) {
  if (isValEmpty(value)) {
    return _defaultStr;
  }

  // While value is tiny scientific notation, like '1.2e-22', it may go wrong
  if (Math.abs(Number(value)) < Number(`0.${'0'.repeat(digit)}5`)) {
    return '0.' + '0'.repeat(digit);
  }

  let result = formatBigNumber(value, digit);
  if (!result || !isPadZero) {
    return result;
  }

  const [integer, decimal] = result?.split('.') ?? [];

  if (!decimal) {
    result = integer + '.' + '0'.repeat(digit);
  } else if (decimal?.length < digit) {
    result = integer + '.' + decimal.padEnd(digit, 0);
  }
  return result;
}

/**
 * 判断是否有权限
 * @param path 
 * @param resourceList 
 * @returns 
 */
export function checkMenusPermission(path: string | string[], resourceList: any[]) {
  if (!path || typeof path === 'string' && ['/', '/403', '404'].includes(path)) {
    return true;
  }
  let hasPermisson = false;
  if (typeof path === 'string') {
    hasPermisson = Boolean(resourceList?.find((item: any) => item.routePath === path && Boolean(item.selected)));
  } else {
    for (let i = 0; i < path.length; i++) {
      if (resourceList?.find((item: any) => item.routePath === path[i])) {
        hasPermisson = true;
        break;
      }
    }
  }
  return hasPermisson;
}
/**
 * 判断是否是外部系统
 * @param path 
 * @returns 
 */
export function isOutsideSystem() {
  const pathname = window.location.pathname.replace('/gvi', '');
  const outsideRoutes = [ROUTER_QUESTIONNAIRE_PREFIX, ROUTER_VERIFICATION, ROUTER_AGREEMENT, ROUTER_OUTSIDE_SUCCESS, ROUTER_HABC_PREFIX, ROUTER_HABC_QUESTIONNAIRE_PREFIX];
  return outsideRoutes.some(route => pathname.startsWith(route));
}

/**
 * 过滤空值
 * @param obj 
 * @param requiredFields 
 * @returns 
 */
export const filterEmptyValues = <T extends Record<string, any>>(
  obj: T, 
  requiredFields: (keyof T)[] = []
): T => {
  const filtered: Record<string, any> = pickBy(obj, (value) => {
    if (isNumber(value)) return true;
    if (typeof value === 'boolean') return true;
    return !isEmpty(value);
  });
  requiredFields.forEach(field => {
    if (!(field in filtered)) {
      filtered[field as string] = obj[field];
    }
  });
  return filtered as T;
};